import css from 'styled-jsx/css';
import { colors, fonts, screen } from 'components/styles/variables';

export default css`
  .end-card {
    font-family: ${fonts.default};
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding-bottom: 25px;
  }

  @media (min-width: ${screen.smMin}) {
    .end-card {
      padding-bottom: 46px;
    }
  }

  .end-image {
    width: 289px;
    height: 157px;
    margin-bottom: 20px;
    border-radius: 16px;
  }

  @media (min-width: ${screen.smMin}) {
    .end-image {
      width: 600px;
      height: 326px;
      margin-bottom: 28px;
    }
  }

  .title {
    font-size: 18px;
    font-weight: 700;
    margin-bottom: 2px;
    color: ${colors.BLACK};
  }

  @media (min-width: ${screen.smMin}) {
    .title {
      font-size: 22px;
      margin-bottom: 4px;
    }
  }

  .subtext {
    font-size: 16px;
    max-width: 237px;
    text-align: center;
    margin-bottom: 16px;
    color: ${colors.G3};
    font-weight: 400;
    line-height: 27px;
  }

  @media (min-width: ${screen.smMin}) {
    .subtext {
      font-size: 18px;
      margin-bottom: 28px;
    }
  }
`;
